var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-alt'),_c('image-and-text',{attrs:{"title":"My Interests","image":"https://imgur.com/YjRlG8O.png","body":_vm.MyInterests,"reversed":""}}),_c('interests-gallery'),_c('info-alt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }